<template>
    <div class="msn-tab-header">
        <div
            v-for="tab in headers"
            :key="tab.value"
        >
            <div class="tab-box">
                <div
                    :class="[`msn-tab${ tab.value === lastVal ? '_active' : ''}`,
                             tab.disabled ? 'disabled' : '',
                             tab === headers[headers.length - 1] ? 'last-tab' : '',
                    ]"
                    @click="handleClick(tab,$event)"
                >
                    <div class="tab-content">
                        {{ $t(tab.label) }}
                    </div>
                </div>
                <el-dropdown
                    v-if="tab.tabOptions && tab.tabOptions.length"
                    trigger="click"
                    @command="handleCommand"
                >
                    <span>
                        <i
                            class="el-icon-arrow-down el-icon--right tab-arrow"
                        ></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                            v-for="item in tab.tabOptions"
                            :key="item.label"
                            :disabled="item.disabled"
                            :command="item"
                        >
                            {{ $t(item.label) }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'MsnTab',
    props: {
        headers: {
            type: Array,
            default() {
                return [];
            }
        },
        lastTabVal: {
            type: String,
            default: ''
        },
        tabOptions: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            lastVal: this.lastTabVal,
            tabData: {}
        };
    },
    methods: {
        /**
         * 处理Tab点击事件
         * @param {Object} tab - 被点击的tab对象
         * @param {Event} event - 点击事件对象
         */
        handleClick(tab, event) {
            if (tab.disabled) {
                return;
            }
            this.$emit('change', tab, this.tabData);
            if (tab.value !== this.lastVal) {
                this.lastVal = tab.value;
                this.tabData = tab;
            }
        },
        /**
         * 处理下拉菜单选择事件
         *
         * 业务说明：
         * 当用户从下拉菜单中选择选项时，需要更新当前激活的tab状态
         * 并将选择结果通知给父组件
         *
         * @param {Object} command - 选中的菜单项
         */
        handleCommand(command) {
            this.updateActiveTab(command);
            this.createTabData(command);
            this.$emit('select', this.tabData);
        },

        /**
         * 更新激活的tab值
         * @param {Object} command - 选中的菜单项
         */
        updateActiveTab(command) {
            this.lastVal = command.value;
        },

        /**
         * 创建tab数据对象
         * @param {Object} command - 选中的菜单项
         */
        createTabData(command) {
            const parentTabIndex = this.findParentTabIndex(command);
            if (parentTabIndex !== -1) {
                this.tabData = this.createMergedTabData(parentTabIndex, command);
            } else {
                this.tabData = command;
            }
        },

        /**
         * 查找包含当前command的父tab索引
         * @param {Object} command - 选中的菜单项
         * @returns {number} 父tab索引，未找到返回-1
         */
        findParentTabIndex(command) {
            return this.headers.findIndex(item => {
                return item.tabOptions && item.tabOptions.some(tab => tab.value === command.value);
            });
        },

        /**
         * 创建合并的tab数据
         * @param {number} parentIndex - 父tab索引
         * @param {Object} command - 选中的菜单项
         * @returns {Object} 合并后的tab数据
         */
        createMergedTabData(parentIndex, command) {
            return {
                ...this.headers[parentIndex],
                value: command.value,
                label: command.label
            };
        }
    },
    watch: {
        lastTabVal(newVal) {
            this.lastVal = newVal;
        }
    }
};
</script>
<style lang="scss" scoped>
    .msn-tab-header {
        height: 50px;
        display: flex;
        border-radius: 6px 6px 0px 0px;
        overflow: hidden;
        cursor: pointer;
        .tab-box{
            position: relative;
            display: flex;
        }
        .msn-tab{
            min-width: 55px;
            height: 50px;
            padding-left: 20px;
            padding-right: 20px;
            background: #F9F9F9;
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 50px;
            color: #53575B;
            opacity: 0.5;
            position: relative;
            border-right: 1px solid #E0E0E0;
            &_active {
                position: relative;
                min-width: 55px;
                height: 50px;
                padding-left: 20px;
                padding-right: 20px;
                font-style: normal;
                font-weight: normal;
                font-size: 16px;
                line-height: 50px;
                border-top: 2px solid #2DD1AC;
                border-right: 1px solid #E0E0E0;
                background: #fff;
                color: #2DD1AC;
                .tab-content{
                    padding: 0 5px;
                }
            }
            .tab-content{
                padding: 0 5px;
            }
        }
        .beta-icon{
            position: absolute;
            top: 0;
            left: 0;
        }
       .msn-fa-beta-1 {
           background-size: 100%;
           width: 40px;
           height: 40px;
       }
        .tab-arrow {
            position: absolute;
            top: 0;
            left: -20px;
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 50px;
            color: #53575B;
            opacity: 0.5;
            margin: 0;
            &_active {
                color: #2DD1AC;
                border-top: 2px solid #2DD1AC;
                font-style: normal;
                font-weight: normal;
                font-size: 16px;
                line-height: 50px;
                margin: 0;
            }
        }
        .disabled {
            cursor: not-allowed;
            &:hover {
                background-color: #f9f9f9 !important;
            }
        }
        .last-tab {
            border-right: none !important;
        }
    }
</style>